import { gql } from '@apollo/client';

const HOLTER_TASKS_QUERY = gql`
  query holterTasks {
    holterTasks {
      isSuccess
      message
      tasks {
        users {
          id
          firstName
          lastName
        }
        study {
          friendlyId
        }
      }
      pendingProfiles {
        id
        study {
          friendlyId
        }
      }
      limitWorker
    }
  }
`;

export default HOLTER_TASKS_QUERY;
